import React from "react";

import { RouterProvider } from "react-router-dom";

import { CssBaseline, ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LicenseInfo } from "@mui/x-license";
import ReactDOM from "react-dom/client";

import "dayjs/locale/id";

import { AuthProvider } from "./features/authentication/auth-provider.jsx";
import { applyYupLocale } from "./features/shared/utils/yup-locale.js";
import { ErrorBoundary } from "./features/ui/error-boundary";
import { SnackbarProvider } from "./features/ui/snackbar/snackbar-provider.jsx";
import router from "./router.jsx";
import { THEME } from "./theme.js";

import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/700.css";

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_LICENSE_KEY);
applyYupLocale();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ThemeProvider theme={THEME}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="id">
        <SnackbarProvider>
          <ErrorBoundary>
            <AuthProvider>
              <RouterProvider router={router} />
            </AuthProvider>
          </ErrorBoundary>
        </SnackbarProvider>
      </LocalizationProvider>
    </ThemeProvider>
  </React.StrictMode>
);
